import React from 'react'
import './style.scss'

function StaticTop ({ show }) {
  return (
    <div
      className="static_top"
      style={{ opacity: show ? 1 : 0 }}
      >
      <img src="https://res.cloudinary.com/oddert/image/upload/v1581962527/Portfolio/logo_five.png" alt="logo" />
    </div>
  )
}

export default StaticTop
